import {Button, Forms, GradientButton, LogoutModal as ULModal} from "@housebets/housebets-x-package";
import {useGTMEvents} from "app/hooks/useGTMEvents";

import {IUserInfoModalProps} from "./types";
import {loginOut} from "../../../../store/slices/user";
import {useNavigate} from "react-router-dom";
import {useIntl} from "react-intl";
import { useDispatch } from "react-redux";
import { useLangNavigate } from "app/hooks/useLangNavigate";
export const LogoutModal: React.FC<IUserInfoModalProps> = ({isOpen, setIsOpen}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {modal} = useGTMEvents();
    const {$t} = useIntl();
    const langNavigate = useLangNavigate();

    function onLogOut() {
        dispatch(loginOut());
        navigate(langNavigate("/"));
    }
    return (
        <ULModal
            onNavBack={undefined}
            afterOpenModal={() => {
                modal.show("user_logout_modal");
            }}
            onAfterClose={() => {
                modal.close("user_logout_modal");
            }}
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}>
            <Forms.LogoutForm.Wrapper>
                <Forms.LogoutForm.WrapperImage>
                    <Forms.LogoutForm.Image />
                </Forms.LogoutForm.WrapperImage>
                <Forms.LogoutForm.Row>
                    <Forms.LogoutForm.Title>{$t({id: "LogoutModal.title"})}</Forms.LogoutForm.Title>
                </Forms.LogoutForm.Row>
                <Forms.LogoutForm.WrapperButtons>
                    <Button
                        themeKind="dark-blue"
                        size="medium-3"
                        noBorder
                        text={"No"}
                        onClick={() => {
                            setIsOpen(false);
                        }}
                    />
                    <GradientButton text={$t({id: "Yes"})} kind="fill" size="md-2" type="submit" onClick={onLogOut} />
                </Forms.LogoutForm.WrapperButtons>
            </Forms.LogoutForm.Wrapper>
        </ULModal>
    );
};

LogoutModal.displayName = "LogoutModal";
